<table
            *ngFor="let scopeData of getScopeData()!.scopeData"
            class="esg-data-table"
        >
            <thead>
                <tr>
                    <th>{{ scopeData.year }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ getEnergyProcessesValue(scopeData) }}</td>
                </tr>
                <tr>
                    <td>{{ getProcurementValue(scopeData) }}</td>
                </tr>
                <tr>
                    <td>{{ getTransportValue(scopeData) }}</td>
                </tr>
                <tr>
                    <td>{{ getWasteRecyclingValue(scopeData) }}</td>
                </tr>
                <tr>
                    <td>{{ getSoldProductsValue(scopeData) }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>{{ scopeData.total ?? 0 }}</td>
                </tr>
            </tfoot>
        </table>
